import type { MemberProfile, MyProfile, ProfilePatch, TeamMember } from '../../types/users'
import { request } from './http'

const patch = (body: ProfilePatch): RequestInit => ({ method: 'PATCH', body: JSON.stringify(body) })

export const getMyProfile = () => request<MyProfile>('/profile')

export const updateMyProfile = (body: ProfilePatch) => request<MyProfile>('/profile', patch(body))

export const listTeam = () => request<TeamMember[]>('/team')

export const getMemberProfile = (userId: string) => request<MemberProfile>(`/admin/users/${userId}/profile`)

export const updateMemberProfile = (userId: string, body: ProfilePatch) =>
	request<MemberProfile>(`/admin/users/${userId}/profile`, patch(body))
